import { Container } from 'inversify';
import getDecorators from 'inversify-inject-decorators';
// services
import { UserService } from './user';
import { UsersService } from './users';
import { PlatformsService } from './platforms';
import { GroupsService } from './groups';
import { NeighbourhoodService } from './neighbourhood';
import { RegisterService } from './register';
import { CommentsService } from './comments';
import { PostsService } from './posts';
import { ContactService } from '@/services/contact';
import { SettingsService } from '@/services/settings';
import { NotificationsService } from './notifications';
import { GroupSubscriptionsService } from './groupSubscriptions';
import { ChatsService } from './chats';
import { SearchService } from "@/services/search";
var container = new Container();
var Services = {
    UsersService: Symbol.for('UsersService'),
    UserService: Symbol.for('UserService'),
    PlatformsService: Symbol.for('PlatformsService'),
    GroupsService: Symbol.for('GroupsService'),
    NeighbourhoodService: Symbol.for('NeighbourhoodService'),
    RegisterService: Symbol.for('RegisterService'),
    CommentsService: Symbol.for('CommentsService'),
    PostsService: Symbol.for('PostsService'),
    ContactService: Symbol.for('ContactService'),
    SettingsService: Symbol.for('SettingsService'),
    NotificationsService: Symbol.for('NotificationsService'),
    GroupSubscriptionsService: Symbol.for('GroupSubscriptionsService'),
    ChatsService: Symbol.for('ChatsService'),
    SearchService: Symbol.for('SearchService'),
};
container.bind(Services.UsersService).to(UsersService);
container.bind(Services.UserService).to(UserService);
container.bind(Services.PlatformsService).to(PlatformsService);
container.bind(Services.GroupsService).to(GroupsService);
container.bind(Services.NeighbourhoodService).to(NeighbourhoodService);
container.bind(Services.RegisterService).to(RegisterService);
container.bind(Services.CommentsService).to(CommentsService);
container.bind(Services.PostsService).to(PostsService);
container.bind(Services.ContactService).to(ContactService);
container.bind(Services.SettingsService).to(SettingsService);
container.bind(Services.NotificationsService).to(NotificationsService);
container.bind(Services.GroupSubscriptionsService).to(GroupSubscriptionsService);
container.bind(Services.ChatsService).to(ChatsService);
container.bind(Services.SearchService).to(SearchService);
var lazyInject = getDecorators(container).lazyInject;
export { container, lazyInject, Services };
